import { Common } from './common';
import {
  CreatedServiceAccount,
  CreateValues,
  ServiceAccount,
  ServiceAccountScope,
  ServiceAccountWithScopes,
  Scope,
  UpdateValues,
} from './models/serviceAccount';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllAvailableScopes(): Promise<Scope[]> {
    const url = this.common.constructPath('/service-accounts/scopes');
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ServiceAccount> {
    const url = this.common.constructPath(`/service-accounts/${id}`);
    return this.common.getJSON(url);
  }

  async findOneWithScopesById(id: string): Promise<ServiceAccountWithScopes> {
    const url = this.common.constructPath(`/service-accounts/${id}`, {
      withScopes: true,
    });
    return this.common.getJSON(url);
  }

  async findOneByToken(
    token: string,
    options: { deleted?: boolean },
  ): Promise<ServiceAccount> {
    const url = this.common.constructPath(`/service-accounts`, {
      token,
      ...options,
    });
    return this.common.getJSON(url);
  }

  async findAll(
    options: {
      deleted?: boolean;
    } = {},
  ): Promise<ServiceAccount[]> {
    const url = this.common.constructPath(`/service-accounts`, options);
    return this.common.getJSON(url);
  }

  async findAllWithScopes(
    options: {
      deleted?: boolean;
    } = {},
  ): Promise<ServiceAccountWithScopes[]> {
    const url = this.common.constructPath(`/service-accounts`, {
      ...options,
      withScopes: true,
    });
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<CreatedServiceAccount> {
    const url = this.common.constructPath(`/service-accounts`);
    return this.common.postJSON(url, values);
  }

  async resetSecret(id: string): Promise<CreatedServiceAccount> {
    const url = this.common.constructPath(`/service-accounts/${id}/reset`);
    return this.common.postJSON(url, {});
  }

  async update(id: string, values: UpdateValues): Promise<ServiceAccount> {
    const url = this.common.constructPath(`/service-accounts/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`/service-accounts/${id}`);
    return this.common.deleteJSON(url);
  }

  async findAllScopes(id: string): Promise<ServiceAccountScope[]> {
    const url = this.common.constructPath(`/service-accounts/${id}/scopes`);
    return this.common.getJSON(url);
  }

  async createScopes(
    id: string,
    scopes: Scope[],
  ): Promise<ServiceAccountScope[]> {
    const url = this.common.constructPath(`/service-accounts/${id}/scopes`);
    return this.common.postJSON(url, { scopes });
  }

  async removeScope(id: string, scopeId: string): Promise<void> {
    const url = this.common.constructPath(
      `/service-accounts/${id}/scopes/${scopeId}`,
    );
    return this.common.deleteJSON(url);
  }
}
